export default function ThankYouCard() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[300px] bg-white rounded-2xl shadow-2xl p-10 border border-blue-100">
      <h2 className="text-3xl font-bold text-blue-700 mb-2">Thank You!</h2>
      <p className="text-lg text-gray-700 mb-4 text-center">
        Your application has been submitted successfully.
        <br />
        We appreciate your interest and will get back to you soon.
      </p>
      <a
        href="https://bsnaustralia.com.au"
        className="mt-4 inline-block bg-blue-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-blue-700 transition"
      >
        Exit
      </a>
    </div>
  );
}
